// extracted by mini-css-extract-plugin
export default {"customBulletPoints":"IconBulletPoint_customBulletPoints__ZRdD-","innerText":"IconBulletPoint_innerText__oA2sa"};